// Persist the player's current room/seat so a tab refresh can restore it.
const KEY = 'chipless:session';

export function getStoredSession() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.roomCode || !parsed.playerId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setStoredSession({ roomCode, playerId, isHost, playerName }) {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ roomCode, playerId, isHost: !!isHost, playerName, storedAt: Date.now() })
    );
  } catch (err) {
    console.warn('sessionStore: failed to save', err);
  }
}

export function clearStoredSession() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}

// --- Game-screen layout preference -----------------------------------------
// Which game layout this DEVICE prefers: 'table' (the oval, default) or 'list'
// (the original). Deliberately local-only — never written to Firebase — so one
// player switching views cannot change what anyone else at the table sees.
const LAYOUT_KEY = 'chipless:gameLayout';

export const GAME_LAYOUTS = { LIST: 'list', TABLE: 'table' };
export const DEFAULT_GAME_LAYOUT = GAME_LAYOUTS.TABLE;

export function getStoredGameLayout() {
  try {
    const value = localStorage.getItem(LAYOUT_KEY);
    return value === GAME_LAYOUTS.TABLE || value === GAME_LAYOUTS.LIST ? value : DEFAULT_GAME_LAYOUT;
  } catch {
    return DEFAULT_GAME_LAYOUT;
  }
}

export function setStoredGameLayout(layout) {
  try {
    if (layout !== GAME_LAYOUTS.TABLE && layout !== GAME_LAYOUTS.LIST) return;
    localStorage.setItem(LAYOUT_KEY, layout);
  } catch (err) {
    console.warn('sessionStore: failed to save layout', err);
  }
}
